import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {useGetSocials, useSocials} from "../stores/contactStore";
import {FaInstagram, FaFacebook, FaTwitter, FaYoutube, FaTelegram, FaWhatsapp} from "react-icons/fa";

const socialIcons = {
    instagram: FaInstagram,
    facebook: FaFacebook,
    twitter: FaTwitter,
    youtube: FaYoutube,
    telegram: FaTelegram,
    whatsapp: FaWhatsapp,
};
const Header = ({ svgColor = "#fff" }) => {
    const [show, setShow] = useState(false);
    const socials = useSocials();
    const getSocials = useGetSocials();
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    useEffect(() => {
        void getSocials();
    }, [getSocials]);
    const toggleMenu = () => setShow((prev) => !prev);

    return (
        <div className="flex container flex-col py-5">
            <div className="flex items-center justify-between px-5 relative">
                <button
                    onClick={toggleMenu}
                    className="w-1/3 md:hidden inline-block"
                >
                    {show ? (
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 6L18 18M6 18L18 6"
                                stroke={svgColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    ) : (
                        // бургер
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 18L20 18M4 12L20 12M4 6L20 6"
                                stroke={svgColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    )}
                </button>

                {/* Навигация (desktop) */}
                <nav className="md:flex w-1/3 hidden items-center text-white gap-10">
                    <Link to={"/"}>Главная</Link>
                    <Link to="/detail/blog/">Блог</Link>
                    <Link to="/detail/contact">Контакты</Link>
                    {user && Object.keys(user).length > 0 && (
                        <Link to="/detail/profile">Профиль</Link>
                    )}
                </nav>

                {/* Логотип */}
                <Link className="w-1/3 flex justify-center" to={"/"}>
                    <img className="md:h-14 md:w-16 w-14 h-12" src={'/image.png'} alt="Логотип Aluu Satuu" />
                </Link>

                <div className="w-1/3 flex justify-end items-center gap-2">
                    {socials.map((ser, idx) => {
                        const Icon = socialIcons[ser.name.toLowerCase()];
                        return (
                            <a
                                key={idx}
                                href={ser.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex justify-center items-center h-5 w-5 md:h-10 md:w-10 rounded-full hover:opacity-50"
                            >
                                {Icon ? <Icon className="md:w-3/4 w-10 h-10 md:h-3/4" /> : ser.name}
                            </a>
                        );
                    })}
                </div>
            </div>

            {/* Мобильное меню */}
            <div
                className={`transition-all duration-500 ease-in-out overflow-hidden md:hidden 
          ${show ? "max-h-[300px] py-1" : "max-h-0 py-0"}
        `}
            >
                <nav className="flex flex-col items-center gap-1 text-white text-sm font-medium">
                    <Link onClick={toggleMenu} to={"/"}>Главная</Link>
                    <Link onClick={toggleMenu} to={"/detail/blog/"}>Блог</Link>
                    <Link onClick={toggleMenu} to={"/detail/contact/"}>Контакты</Link>
                    {user && Object.keys(user).length > 0 && (<Link onClick={toggleMenu} to={"/detail/profile"}>Профиль</Link>)}
                </nav>
            </div>
        </div>
    );
};

export default Header;
